"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@opentelemetry/api");
const context_zone_1 = require("@opentelemetry/context-zone");
const exporter_trace_otlp_http_1 = require("@opentelemetry/exporter-trace-otlp-http");
const instrumentation_1 = require("@opentelemetry/instrumentation");
const instrumentation_fetch_1 = require("@opentelemetry/instrumentation-fetch");
const resources_1 = require("@opentelemetry/resources");
const sdk_trace_base_1 = require("@opentelemetry/sdk-trace-base");
const sdk_trace_web_1 = require("@opentelemetry/sdk-trace-web");
const useTracing = ({ enableTracing = true, serviceName, otelUrl, }) => {
    const resource = new resources_1.Resource({ "service.name": serviceName });
    const provider = new sdk_trace_web_1.WebTracerProvider({ resource });
    const collector = new exporter_trace_otlp_http_1.OTLPTraceExporter({
        url: `${otelUrl}/v1/traces`,
    });
    provider.addSpanProcessor(new sdk_trace_base_1.SimpleSpanProcessor(collector));
    provider.register({ contextManager: new context_zone_1.ZoneContextManager() });
    const webTracerWithZone = provider.getTracer(serviceName);
    let bindingSpan;
    window.startBindingSpan = (traceId, spanId, traceFlags) => {
        bindingSpan = webTracerWithZone.startSpan("");
        bindingSpan.spanContext().traceId = traceId;
        bindingSpan.spanContext().spanId = spanId;
        bindingSpan.spanContext().traceFlags = traceFlags;
    };
    const initTracing = () => {
        if (enableTracing) {
            (0, instrumentation_1.registerInstrumentations)({
                instrumentations: [
                    new instrumentation_fetch_1.FetchInstrumentation({
                        propagateTraceHeaderCorsUrls: ["/.*/g"],
                        ignoreUrls: [
                            RegExp("^(http|https):?(?:[^.]+.)?(.*).googleapis.com(.*)?$"),
                        ],
                        clearTimingResources: true,
                        applyCustomAttributesOnSpan: (span, request, result) => {
                            const attributes = span.attributes;
                            const hasError = (result && (result === null || result === void 0 ? void 0 : result.status) >= 400) || result instanceof Error;
                            if (hasError)
                                span.setStatus({ code: api_1.SpanStatusCode.ERROR });
                            if (attributes.component === "fetch") {
                                span.updateName(`${attributes["http.method"]} ${attributes["http.url"]}`);
                            }
                            if (result instanceof Error) {
                                span.setStatus({
                                    code: api_1.SpanStatusCode.ERROR,
                                    message: result.message,
                                });
                                span.recordException(result.stack || result.name);
                            }
                        },
                    }),
                ],
            });
        }
    };
    const addAttrsToSpan = (span, attrs) => attrs === null || attrs === void 0 ? void 0 : attrs.forEach((attr) => {
        span.setAttribute(attr.key, attr.value);
    });
    const traceSpan = (name, func, attrs) => {
        if (enableTracing) {
            let singleSpan;
            if (bindingSpan) {
                const ctx = api_1.trace.setSpan(api_1.context.active(), bindingSpan);
                singleSpan = webTracerWithZone.startSpan(name, undefined, ctx);
                bindingSpan = undefined;
            }
            else {
                singleSpan = webTracerWithZone.startSpan(name);
            }
            const hasError = attrs === null || attrs === void 0 ? void 0 : attrs.some((item) => item.key === "Error");
            if (hasError)
                singleSpan.setStatus({ code: api_1.SpanStatusCode.ERROR });
            return api_1.context.with(api_1.trace.setSpan(api_1.context.active(), singleSpan), () => {
                try {
                    const result = func();
                    addAttrsToSpan(singleSpan, attrs);
                    singleSpan.end();
                    return result;
                }
                catch (error) {
                    singleSpan.setAttribute("Error", JSON.stringify(error));
                    singleSpan.setStatus({ code: api_1.SpanStatusCode.ERROR });
                    addAttrsToSpan(singleSpan, attrs);
                    singleSpan.end();
                    throw error;
                }
            });
        }
        else {
            return func();
        }
    };
    return {
        traceSpan,
        initTracing,
    };
};
exports.default = useTracing;
//# sourceMappingURL=useTracing.js.map